import { ValueOf } from '@/types/util';

export const EGiftType = {
  NORMAL: '通常',
  BENEFITS: '給付金',
} as const;

export type GiftTypeKey = keyof typeof EGiftType;
export type GiftTypeValue = ValueOf<typeof EGiftType>;

export const giftTypeKeys = Object.keys(EGiftType) as GiftTypeKey[];

/** v-select用items */
export const giftTypeItems = giftTypeKeys
  .map((key) => ({
    title: EGiftType[key],
    value: key,
  }));
